import HomeBanner from './HomeBanner.jsx';
import HighlightPromotionContainer from './HighlightPromotionContainer.jsx';
import FavoriteCategoryContainer from './FavoriteCategoryContainer.jsx';
import HighlightProductByCategoryContainer from './HighlightProductByCategoryContainer.jsx';
import TradeNewsContainer from './TradeNewsContainer.jsx';
import EasyNeedOfferContainer from './EasyNeedOfferContainer.jsx';
import NeedOffersByCategoryContainer from './NeedOffersByCategoryContainer.jsx';
import SupportInfoContainer from './SupportInfoContainer.jsx';
import NewsLetterRegister from './NewsLetterRegister.jsx';
import HighlightNeedOfferTab from './HighlightNeedOfferTab.jsx';
import TopBusinessTab from './TopBusinessTab.jsx';
import TopProductTab from './TopProductTab.jsx';
import HotProducts from './HotProducts.jsx';
import ProductsByCategory from './ProductsByCategory.jsx';
import HighlightBusinessesContainer from './HighlightBusinessesContainer.jsx';
import HighlightProductByCategoryContainerOCOOP from './HighlightProductByCategoryContainerOCOOP.jsx'

export {
  HomeBanner,
  HighlightPromotionContainer,
  FavoriteCategoryContainer,
  HighlightProductByCategoryContainer,
  TradeNewsContainer,
  EasyNeedOfferContainer,
  NeedOffersByCategoryContainer,
  SupportInfoContainer,
  NewsLetterRegister,
  HighlightNeedOfferTab,
  TopBusinessTab,
  TopProductTab,
  HotProducts,
  ProductsByCategory,
  HighlightBusinessesContainer,
  HighlightProductByCategoryContainerOCOOP
}



// WEBPACK FOOTER //
// ./components/home/sub-view/index.js